// Which way a finger swipe goes, for the profile blocks that show one item at
// a time with arrows (Hot Take, Currently Reading). The hook that listens for
// the touches is src/hooks/useSwipe.js; this is the rule it applies, kept
// apart so a node check can test it without React.

// 40px is the distance the two swipes that already exist use: the Match Me
// card (MatchMeCard.jsx, onTouchEnd) and the homepage pipelines
// (ReaderHomepage.jsx, onTouchEnd). Same finger, same feel.
export const SWIPE_MIN_PX = 40;

// The one thing those two do not check, and these blocks have to: a profile
// is a long page that a reader scrolls up and down, and a scroll is rarely
// perfectly straight. Without this, a slightly diagonal scroll past the block
// would flip it. The finger has to travel clearly more sideways than up or
// down, 1.5 times as far, before it counts as a swipe.
export const SWIPE_SIDEWAYS_RATIO = 1.5;

// +1 for the next slide (the finger moved left, as when turning a page),
// -1 for the previous one, 0 for not a swipe. dx and dy are where the finger
// lifted minus where it went down, in pixels.
export function swipeStep(dx, dy) {
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return 0;
  if (Math.abs(dx) < SWIPE_MIN_PX) return 0;
  if (Math.abs(dx) <= Math.abs(dy) * SWIPE_SIDEWAYS_RATIO) return 0;
  return dx < 0 ? 1 : -1;
}
